module.exports = __webpack_public_path__ + "img/avatar.b7bb3483.svg";